<template>
  <AppHeader />
  <section>
    <div class="text-center pt-5 mb-8">
      <h1>You have been logged out.</h1>
      <Button label="Log in" severity="info" @click="login" />
    </div>
  </section>
  <app-footer :build-info="buildInfo" />
</template>

<script setup lang="ts">
import { provide, ref } from "vue";
import router from "@/router";
import { useAuth } from "@okta/okta-vue";
import { useDark } from "@vueuse/core";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import buildInfo from "@/assets/generated/build-info.json";
import { buildInfoKey } from "@/injectionKeys";

const authClient = useAuth();
const isAuthenticated = ref(false);

provide(buildInfoKey, buildInfo);

isAuthenticated.value =
  authClient.authStateManager.getAuthState()?.isAuthenticated || false;

if (isAuthenticated.value) {
  router.push({
    name: "Home"
  });
}

function login() {
  authClient.signInWithRedirect();
}

// TODO: abstact isDark stuff since it is used in multiple places,
// or replace with state management

const isDark = useDark({
  selector: "html",
  attribute: "data-theme",
  valueLight: "",
  valueDark: "dark"
});

provide("isDarkMode", isDark);
</script>
